export default [
  {
    id: 1,
    name: 'Getting Started',
    icon: '🚀',
    description: 'Quick guides to help new users onboard.',
    slug: 'getting-started',
    meta: {
      articles_count: 5,
    },
  },
  {
    id: 2,
    name: 'Advanced Features',
    icon: '💡',
    description: 'Explore advanced features for power users.',
    slug: 'advanced-features',
    meta: {
      articles_count: 8,
    },
  },
  {
    id: 3,
    name: 'FAQs',
    icon: '❓',
    description: 'Commonly asked questions and helpful answers.',
    slug: 'faqs',
    meta: {
      articles_count: 3,
    },
  },
  {
    id: 4,
    name: 'Troubleshooting',
    icon: '🛠️',
    description: 'Resolve common issues with step-by-step guidance.',
    slug: 'troubleshooting',
    meta: {
      articles_count: 6,
    },
  },
  {
    id: 5,
    name: 'Community Guidelines',
    icon: '👥',
    description: 'Rules and practices for community engagement.',
    slug: 'community-guidelines',
    meta: {
      articles_count: 2,
    },
  },
  {
    id: 6,
    name: 'Account Management',
    icon: '🔑',
    description: 'Manage your account and settings efficiently.',
    slug: 'account-management',
    meta: {
      articles_count: 7,
    },
  },
  {
    id: 7,
    name: 'Security Tips',
    icon: '🔒',
    description: 'Best practices for securing your account.',
    slug: 'security-tips',
    meta: {
      articles_count: 4,
    },
  },
  {
    id: 8,
    name: 'Integrations',
    icon: '🔗',
    description: 'Connect to third-party services and tools easily.',
    slug: 'integrations',
    meta: {
      articles_count: 9,
    },
  },
  {
    id: 9,
    name: 'Billing & Payments',
    icon: '💳',
    description: 'Manage your billing and payment details seamlessly.',
    slug: 'billing-payments',
    meta: {
      articles_count: 5,
    },
  },
  {
    id: 10,
    name: 'Customization',
    icon: '🎨',
    description: 'Personalize and customize your user experience.',
    slug: 'customization',
    meta: {
      articles_count: 7,
    },
  },
  {
    id: 11,
    name: 'Notifications',
    icon: '🔔',
    description: 'Adjust your notification settings and preferences.',
    slug: 'notifications',
    meta: {
      articles_count: 3,
    },
  },
  {
    id: 12,
    name: 'Privacy',
    icon: '🛡️',
    description: 'Understand how your data is collected and used.',
    slug: 'privacy',
    meta: {
      articles_count: 2,
    },
  },
  {
    id: 13,
    name: 'Mobile App',
    icon: '📱',
    description: 'Guides for using the mobile app effectively.',
    slug: 'mobile-app',
    meta: {
      articles_count: 6,
    },
  },
  {
    id: 14,
    name: 'Beta Features',
    icon: '🧪',
    description: 'Learn about new experimental features in beta.',
    slug: 'beta-features',
    meta: {
      articles_count: 4,
    },
  },
];
